import {SvgTcddTrainRules} from '../../shared/svg-rules/tcdd/svg-tcdd-train-rules';
import {TcddSubSystem} from '../../shared/enums/tcdd-sub-system.enum';
import {TCDD_UNIT} from '../../shared/constants/tcdd-unit-constant';

export class TcddTrainErrorDetectionService {

  constructor() {
  }

  /**
   * Checks if all system have errors.
   * @param trainData - The processed train system data.
   * @param wagonsData - The processed wagons system data.
   * @returns True if any system has errors; otherwise, false.
   */
  public hasSystemErrors(trainData: any, wagonsData: any): boolean {
    if (!trainData || !wagonsData) return false;
    const trainSystems: string[] = Object.keys(trainData);
    const wagonSystems: string[] = Object.keys(wagonsData);

    const trainHasError = trainSystems.some((system: string) =>
      this.hasErrorsInTrain(system, trainData)
    );

    const wagonHasError = wagonSystems.some((system: string) =>
      this.hasErrorsInWagons(system, wagonsData)
    );

    // Returns true if any of them have errors
    return trainHasError || wagonHasError;
  }

  /**
   * Checks if a specific train has errors.
   * @param system - The system name.
   * @param data - The processed system data.
   * @returns True if the system has errors; otherwise, false.
   */
  public hasErrorsInTrain(system: any, data: any): boolean {
    if (!data || !data[system] || !system) return false;

    // Retrieve the rule for the 'wagon-error' target from the main system rules
    const iconRule: any | undefined = SvgTcddTrainRules.getRules()?.[TcddSubSystem.MAIN_SYSTEM]?.find((rule: any) => rule.target === TCDD_UNIT.TITLE_ICON);
    if (!iconRule) return false; // Exit early if no relevant rule is found

    return iconRule.condition(system, null, data);
  }

  /**
   * Checks if a specific wagons has errors.
   * @param system - The system name.
   * @param data - The processed system data.
   * @returns True if the system has errors; otherwise, false.
   */
  public hasErrorsInWagons(system: any, data: any): boolean {
    if (!data || !data[system] || data[system].length === undefined || !system) return false;

    // Retrieve the rule for the 'wagon-error' target from the main system rules
    const iconRule: any | undefined = SvgTcddTrainRules.getRules()?.[TcddSubSystem.MAIN_SYSTEM]?.find((rule: any) => rule.target === TCDD_UNIT.TITLE_ICON);
    if (!iconRule) return false; // Exit early if no relevant rule is found

    // Iterate through the wagons to check if any condition is met
    return data[system].some((_, wagonIndex: number) => iconRule.condition(system, wagonIndex, data));
  }
}
